import { forwardRef, type Ref, type SVGProps } from "react";
const IconInfoFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m-.09 7.66a1.53 1.53 0 1 1-1.53 1.53 1.5 1.5 0 0 1 1.53-1.53m2.44 12.68h-4.7a1.23 1.23 0 1 1 0-2.45h1.26v-3.41h-1.07a1.23 1.23 0 1 1 0-2.45h2.37a1.15 1.15 0 0 1 1.25 1.23v4.63h.89a1.23 1.23 0 1 1 0 2.45" /></svg>;
const ForwardRef = forwardRef(IconInfoFilledSVG);
ForwardRef.displayName = "IconInfoFilled";
export { ForwardRef as IconInfoFilled };